import { useCallback, useEffect, useState } from "react";
import { api } from "../lib/api";
import Nav from "../components/Nav";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import AddPiece from "../components/AddPiece";
import Gallery from "../components/Gallery";
import ArtBand from "../components/ArtBand";
import Commissions from "../components/Commissions";
import Footer from "../components/Footer";

export default function Home() {
  const [artworks, setArtworks] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchArtworks = useCallback(async () => {
    try {
      const res = await api.get("/artworks");
      setArtworks(res.data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchArtworks();
  }, [fetchArtworks]);

  const handleAdded = useCallback((art) => {
    setArtworks((prev) => [art, ...prev]);
  }, []);

  const handleRemoved = useCallback((id) => {
    setArtworks((prev) => prev.filter((a) => a.id !== id));
  }, []);

  return (
    <div className="bg-ground text-ink min-h-screen selection:bg-gold selection:text-black">
      <Nav />
      <Hero />
      <Marquee />
      <AddPiece onAdded={handleAdded} />
      <Gallery artworks={artworks} loading={loading} onRemoved={handleRemoved} />
      <ArtBand />
      <Commissions />
      <Footer />
    </div>
  );
}
